/* eslint-disable */
import React, { useCallback, useEffect, useRef, useState } from "react";
import moment from "moment";
import { EditPageHeader } from "../../components/EditPageHeader";
import { useTranslation } from "../../locale/useTranslation";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Grid, GridColumn, getSelectedState } from '@progress/kendo-react-grid';
import * as API from "../../framework/API/api"
import { ENTITYNAME, TOAST_TYPES } from "../../framework/constant/constant";
import { getter } from "@progress/kendo-data-query";
import CustomPaginationDropDown from "../../framework/forms/helpercomponents/CustomGridCells/CustomPaginationDropDown";
import BossDialog from "../../components/BossDialog";
import { utility } from "../../framework/utility/utilityProvider";
import { ImageCell } from "../../framework/forms/helpercomponents/CustomGridCells/ImageCell";
import RoundButton from "../../framework/forms/helpercomponents/buttons/RoundButton";
import ToastNotification from "../../components/ToastNotification";
import { Loader } from "../../framework/forms/helpercomponents/Loader";

const SPORTS_DATE_FORMATS = [
    moment.ISO_8601,
    "YYYY-MM-DD",
    "YYYY-M-D",
    "YYYY/MM/DD",
    "DD-MM-YYYY",
    "DD/MM/YYYY",
    "MM/DD/YYYY",
    "MMM DD YYYY",
    "MMM DD, YYYY",
    "DD MMM YYYY",
    "DD MMM, YYYY",
    "MMM DD",
    "MMM D",
    "DD MMM",
    "D MMM",
];

const SPORTS_FALLBACK_FORMATS = [
    "YYYY MMM DD",
    "YYYY MMM D",
    "YYYY DD MMM",
    "YYYY D MMM",
    "YYYY-MM-DD",
    "YYYY-M-D",
    "YYYY/MM/DD",
];

const formatSportsDate = (value) => {
    if (!value) {
        return "";
    }

    const parsedDate = moment(String(value).trim(), SPORTS_DATE_FORMATS, true);
    if (parsedDate.isValid()) {
        return parsedDate.format("DD MMM YYYY");
    }

    const fallbackDate = moment(value);
    if (fallbackDate.isValid()) {
        return fallbackDate.format("DD MMM YYYY");
    }

    return value;
};

const SportsDateCell = (cellProps) => (
    <td>
        {formatSportsDate(cellProps.dataItem?.[cellProps.field])}
    </td>
);

const parseSportsDate = (value, fallbackYear = null) => {
    if (value == null || value === "") {
        return null;
    }

    const rawValue = String(value).trim();
    if (!rawValue) {
        return null;
    }

    let parsedDate = moment(rawValue, SPORTS_DATE_FORMATS, true);

    if (!parsedDate.isValid() && fallbackYear) {
        parsedDate = moment(`${fallbackYear} ${rawValue}`, SPORTS_FALLBACK_FORMATS, true);
    }

    if (!parsedDate.isValid()) {
        parsedDate = moment(rawValue);
    }

    return parsedDate.isValid() ? parsedDate.startOf("day") : null;
};

const resolveSportsTournamentDates = (startDate, endDate) => {
    const currentYear = moment().year();
    let startMoment = parseSportsDate(startDate, currentYear);
    let endMoment = parseSportsDate(endDate, startMoment?.year() ?? currentYear);

    if (!startMoment && endMoment) {
        startMoment = endMoment.clone();
    }

    if (!endMoment && startMoment) {
        endMoment = startMoment.clone();
    }

    if (!startMoment || !endMoment) {
        return null;
    }

    const endHadExplicitYear = endDate != null && /\d{4}/.test(String(endDate));
    if (!endHadExplicitYear && endMoment.isBefore(startMoment, "day")) {
        endMoment = endMoment.clone().add(1, "year");
    }

    return {
        startDate: startMoment.valueOf(),
        endDate: endMoment.valueOf(),
    };
};

const DATA_ITEM_KEY = "id";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);

const SportsEventEditForm = (props) => {

    const lang = useTranslation();
    const isMountedRef = useRef(true);

    const blankDataItem = {
        SearchName: "",
        TournamentType : {},
    }

    const getDataWithIMDBId = async (imdbId) => {
        let res = await API.getIMDBDetails(imdbId);
        if (res.success) {
            setGridData([res.data]);
            setDataItem({ ...dataItem, SearchName: res.data.Title });
            setSelectedItemDetails(res.data);
            setSelectedState({ [imdbId]: true });
        }
    }

    useEffect(() => {
        loadCombo();
        // if (props?.IMDbID) {
        //     getDataWithIMDBId(props?.IMDbID);
        // }
    }, [props?.IMDbID]);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [gridData, setGridData] = useState([]);
    const [selectedState, setSelectedState] = useState({});
    const [selectedStateMatch, setSelectedStateMatch] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState("");

    const [selectedItemDetails, setSelectedItemDetails] = useState([]);
    const initialDataState = {
        skip: 0,
        take: 25,
    };
    const [page, setPage] = useState(initialDataState);
    const [total, setTotal] = useState(1);
    const [tournamentType, setTournamentType] = useState([]);

    const loadCombo = async () => {
        let tournamentType = await API.getDataLookup(ENTITYNAME.TournamentType, { sort: { Description: 1 } });
        setTournamentType(tournamentType.data);
    }

    const runWithLoader = async (message, action) => {
        setLoadingMessage(message);
        setIsLoading(true);
        try {
            return await action();
        } finally {
            if (isMountedRef.current) {
                setIsLoading(false);
                setLoadingMessage("");
            }
        }
    };

    const onChange = (e) => {
        setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    }

    const onSearch = async () => {
        if (isLoading) {
            return;
        }

        // if (!dataItem.SearchName || dataItem.SearchName == "") {
        //     ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_search_name_error_message });
        //     return;
        // }

        // if (!dataItem.TournamentType || Object.keys(dataItem.TournamentType).length == 0) {
        //     ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_type_error_message });
        //     return;
        // }
        let payload = {
            searchKey: dataItem.SearchName,
            TournamentType: dataItem.TournamentType?.Description,
            page: (page.skip / page.take),
        };

        await runWithLoader("Searching tournaments...", async () => {
            let res = await API.getSportsEventTournaments(payload);
            console.log(res);
            if (res.success) {
                setPage(initialDataState);
                setGridData(res.data);
                setTotal(res.pagination?.total);
                setSelectedState({});
                setSelectedItemDetails({});
            } else {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
            }
        });
    }

    const onSelectionChange = useCallback(
        async (event) => {
            if (isLoading) {
                return;
            }

            const newSelectedState = getSelectedState({
                event,
                selectedState: selectedState,
                dataItemKey: DATA_ITEM_KEY,
            });

            console.log(gridData.find((item) => newSelectedState[item.id]))
            let tournamentId = gridData.find((item) => newSelectedState[item.id])?.id;
            if (!tournamentId) {
                setSelectedState(newSelectedState);
                return;
            }

            await runWithLoader("Loading matches...", async () => {
                let res = await API.getSportsEventTournamentMatches(tournamentId);
                console.log(res);
                if (res.success) {
                    setSelectedItemDetails(res.data);
                } else {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
                }
            });
            setSelectedState(newSelectedState);
        },
        [selectedState, gridData, isLoading]
    );

    const onMatchSelectionChange = useCallback(
        async (event) => {
            const newSelectedState = getSelectedState({
                event,
                selectedState: selectedState,
                dataItemKey: DATA_ITEM_KEY,
            });
            setSelectedStateMatch(newSelectedState);
        },
        [selectedStateMatch]
    );

    const pageChange = async (e) => {
        if (isLoading) {
            return;
        }

        let payload = {
            searchKey: dataItem.SearchName,
            TournamentType: dataItem.TournamentType?.Description,
            page: (e.page.skip / e.page.take),
        }

        await runWithLoader("Searching tournaments...", async () => {
            let res = await API.getSportsEventTournaments(payload);
            if (res.success) {
                setGridData(res.data);
                setSelectedState({});
                setSelectedItemDetails({});
                setPage(e.page);
            } else {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
            }
        });
    };

    const handleSubmit = async () => {
        if (!selectedItemDetails || selectedItemDetails.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_item_first_error_message });
            return;
        }
    }

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            onSearch();
        }
    };

    const onIngest = async (data) => {
        if (isLoading) {
            return;
        }

        await runWithLoader("Loading matches...", async () => {
            const matchRes = await API.getSportsEventTournamentMatches(data.id);

            if (!matchRes.success) {
                ToastNotification({
                    type: TOAST_TYPES.ERROR,
                    title: lang.invalid_error_message_title,
                    message: matchRes.message,
                });
                return;
            }

            const resolvedDates = resolveSportsTournamentDates(data.startDate, data.endDate);
            if (!resolvedDates) {
                ToastNotification({
                    type: TOAST_TYPES.ERROR,
                    title: lang.invalid_error_message_title,
                    message: "Unable to read tournament dates from the sports feed.",
                });
                return;
            }

            let tournament = {
                Name: data.name,
                StartDate: resolvedDates.startDate,
                EndDate: resolvedDates.endDate,
                TournamentID: data.id,
                TournamentType: dataItem.TournamentType,
                isFromSportsAPI: true,
                fetchAllMatches: true,
                selectedMatches: matchRes.data ?? [],
                PosterUrl: "",
                Archive: false
            };

            props.sportsTournamentList(tournament);
            props.cancelEdit();
        });
    }

    const MyCommandCell = (props) => (
        <div className="mt-1" style={{ display: "flex", justifyContent: "center", width: "100%" }}>
            <RoundButton icon={"save"} title={"Ingest"} onClick={() => onIngest(props.dataItem)} isLoading={isLoading} />
        </div>
    )

    return (
        <BossDialog
            title={lang.sports_event_label}
            onClose={props.cancelEdit}
            width={"70%"}
        >
            <div style={{ position: "relative" }}>
                {isLoading && (
                    <div style={{ position: "absolute", inset: 0, zIndex: 5, backgroundColor: "rgba(255,255,255,0.72)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <Loader height="160px" width="320px" bgColor="transparent" description={loadingMessage} />
                    </div>
                )}

            <EditPageHeader showTitle={false} showSaveButton={false} onSubmit={() => { }} onCancel={props.cancelEdit} isLoading={isLoading} />

            <div className="row mt-2">
                <div className="col-3">
                    <label>{lang.tournament_type_label} *</label>
                    <DropDownList
                        style={{ backgroundColor: "white" }}
                        data={tournamentType}
                        name="TournamentType"
                        textField="Description"
                        dataItemKey="SID"
                        value={dataItem.TournamentType}
                        onChange={onChange}
                        disabled={isLoading}
                    // disabled={props?.mediaCategory ? true : false}
                    />
                </div>
                <div className="col-5">
                    <label>{lang.search_button_text}</label>
                    <div className="input-group">
                        <input
                            type="text"
                            className="form-control form-control-sm shadow-inset-2"
                            id="searchInput"
                            name="SearchName" value={dataItem.SearchName}
                            onChange={(e) => setDataItem({ ...dataItem, SearchName: e.target.value })}
                            onKeyDown={handleKeyDown}
                            placeholder={lang.search_name_label}
                            disabled={isLoading}
                            onFocus={(e) => {
                                if (props.setOutSideFocus) {
                                    props.setOutSideFocus(true);
                                }
                            }}
                            onBlur={(e) => {
                                if (props.setOutSideFocus) {
                                    props.setOutSideFocus(false);
                                }
                            }}
                        />
                        <button
                            id="search"
                            type="button"
                            style={{ border: "0px", backgroundColor: "white", height: "30px" }}
                            onClick={onSearch}
                            disabled={isLoading}
                        >
                            <span className="input-group-text" style={{ height: '32px' }}>
                                <i style={{ margin: "4px 0px" }} className={isLoading ? "fa fa-spinner fa-spin" : "fa fa-search"} />
                            </span>
                        </button>
                    </div>
                </div>
            </div>

            <div className="row mt-3 imdb">
                <div className={(gridData?.filter((item) => selectedState[idGetter(item)]).length != 0) ? "col-5" : "col-12"}>
                    <Grid
                        data={gridData.map((item) => ({
                            ...item,
                            [SELECTED_FIELD]: selectedState[idGetter(item)],
                        }))}
                        dataItemKey={DATA_ITEM_KEY}
                        selectedField={SELECTED_FIELD}
                    selectable={{
                            enabled: true,
                            drag: false,
                            cell: false,
                            mode: "single",
                        }}
                        pageable={true}
                        skip={page.skip}
                        take={page.take}
                        total={total}
                        onPageChange={pageChange}
                        onSelectionChange={onSelectionChange}
                        resizable={true}
                        style={{ height: "480px" }}
                        pager={(props) => <CustomPaginationDropDown {...props} />}

                    >
                        <GridColumn cell={MyCommandCell} width={"100px"} />
                        <GridColumn field="name" title={lang.name_column} width={"280px"} />
                        <GridColumn field="startDate" title={lang.start_date_column} width={"150px"} cell={SportsDateCell} />
                        <GridColumn field="endDate" title={lang.end_date_column} width={"150px"} cell={SportsDateCell} />
                        {/* <GridColumn field="imdbID" title={lang.imdb_id_column} /> */}
                        {/* <GridColumn field="matchType" title={lang.match_type_label} /> */}
                    </Grid>
                </div>
                {(gridData.filter((item) => selectedState[idGetter(item)]).length != 0) && <div className="col-7 border">
                    <div className="flex-container">
                        <div className="flex-container-reverse flex-item-auto">

                            <div className="mt-1" style={{ paddingTop: "12px" }}>
                                <RoundButton
                                    icon={"xmark"}
                                    // btnColor={"warning"}
                                    // style={{ margin: "0px 03px" }}
                                    // iconColor={"white"}
                                    title={lang.cancel_button_text}
                                    onClick={() => { setSelectedState({}); setSelectedItemDetails({}) }}
                                    isLoading={isLoading}
                                />
                            </div>


                        </div>
                    </div>
                    <div className="row mt-2">
                        <Grid
                            data={selectedItemDetails.map((item) => ({
                                ...item,
                                [SELECTED_FIELD]: selectedState[idGetter(item)],
                            }))}
                            // data={selectedItemDetails}
                            
                        dataItemKey={DATA_ITEM_KEY}
                        selectedField={SELECTED_FIELD}
                        selectable={{
                            enabled: true,
                            drag: false,
                            cell: false,
                            mode: "single",
                        }}
                        onSelectionChange={onMatchSelectionChange}
                        resizable={true}
                        style={{ height: "43vh" }}

                        >
                            <GridColumn field="teamA.img" title={lang.team_a_label} width={80} cell={ImageCell} />
                            <GridColumn field="teamB.img" title={lang.team_b_label} width={80} cell={ImageCell} />
                            <GridColumn field="teamA.name" title={"Team A"} />
                            <GridColumn field="teamB.name" title={"Team B"} />
                            <GridColumn field="dateTimeGMT" title={lang.start_date_column} />
                            <GridColumn field="matchType" title={lang.match_type_label} />
                            <GridColumn field="venue" title={lang.venue_label} />
                        </Grid>

                    </div>
                </div>}
            </div>

            </div>
        </BossDialog >
    )
}

export default SportsEventEditForm;
